<template>
	<button
		class="flex w-full items-center justify-between gap-2"
		@click="handleLogout"
	>
		<span class="text-base font-normal leading-[24px]">Sair da conta</span>
		<IconMaterialSymbolsLightLogoutSharp
			class="size-6 cursor-pointer text-primary-light-1"
		/>
	</button>
</template>

<script setup lang="ts">
const emit = defineEmits<{
	(e: 'logout'): void;
}>();

const handleLogout = () => {
	emit('logout');
};
</script>
